// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".canvas-control{position:fixed;top:0;left:0;z-index:99999}.canvas-control--rotate-button{font-size:32px;color:#333;padding:16px;background-color:hsla(0,0%,100%,.5)}.canvas-control.portrait-orientation .canvas-control--rotate-button{-webkit-transform:rotate(90deg);transform:rotate(90deg)}", ""]);
// Exports
module.exports = exports;
